import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {VehicleBrand} from '../../../../domain/core/vehicle-brand.model';

@Component({
    selector: 'app-action-buttons',
    templateUrl: './action-buttons.component.html',
    imports: [CommonModule]
})
export class ActionButtonsComponent {
  @Input() showSaveButtons = false;
  @Input() dirty = false;
  @Input() willDenyCC = false;
  @Input() willDenyCE = false;
  @Input() noPreferredDealerError = false;
  @Input() noPreferredDealerLexusError = false;
  @Input() brand: VehicleBrand;
  @Output() save = new EventEmitter();
  @Output() cancel =  new EventEmitter();

  showErrorMessage() {
    if (this.showSaveButtons) {
      if (this.willDenyCC && !this.willDenyCE ||
        this.willDenyCE && !this.willDenyCC ||
        this.noPreferredDealerError || this.noPreferredDealerLexusError)
      {
        return true;
      }
    }
    return false;
  }
}
